"use strict";

exports.__esModule = true;
exports.MINUTES = exports.HOUR = exports.DATE = exports.YEAR = void 0;
var YEAR = 'year';
exports.YEAR = YEAR;
var DATE = 'date';
exports.DATE = DATE;
var HOUR = 'hours';
exports.HOUR = HOUR;
var MINUTES = 'minutes';
exports.MINUTES = MINUTES;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/constants/date-picker-view.js
// module id = 84
// module chunks = 0